
import React from "react";
import styles from "./Impact.module.css";
import { ImpactTypes } from "@/types/displayData/ImpactTypes";
import { CircleCheck } from "lucide-react";

const ImpactComponent: React.FC<ImpactTypes> = ({ title, subtitle, sections, images }) => {
  return (
    <section className={styles.impactContainer}>
      <h2 className={styles.impactTitle}>{title}</h2>
      <h3 className={styles.impactSubtitle}>{subtitle}</h3>

      <div className={styles.contentWrapper}>
        <div className={styles.textContent}>
          <div className={styles.impactList}>
            {sections.map((section, index) => (
              <div key={index} className={styles.impactItem}>
                <div className={styles.iconContainer}>
                  <CircleCheck className={styles.impactIcon} />
                </div>
                <div>
                  <h4 className={styles.impactItemTitle}>{section.title}</h4>
                  <p className={styles.impactItemDescription}>{section.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.imageContainer}>
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Impact ${index + 1}`}
              className={`${styles.impactImage} ${styles[`image${index}`]}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactComponent;
